import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const WhatsAppFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '243818883531';
    const message = encodeURIComponent('Bonjour ORAZEK, je souhaite obtenir des informations sur vos services.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 md:bottom-8 md:left-8 z-50">
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-4 w-48 md:w-64 bg-white rounded-lg shadow-premium-lg p-4 border border-[var(--color-border)] animate-fade-in">
          <div className="absolute -bottom-2 left-6 w-4 h-4 bg-white border-r border-b border-[var(--color-border)] transform rotate-45"></div>
          <p className="text-sm text-[var(--color-foreground)] font-medium mb-1">
            Besoin d'aide?
          </p>
          <p className="text-xs text-[var(--color-muted-foreground)]">
            Contactez-nous sur WhatsApp pour une réponse rapide!
          </p>
        </div>
      )}

      <button
        onClick={handleWhatsAppClick}
        className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#20BA5A] shadow-premium-lg hover:shadow-premium-xl transition-all duration-300 flex items-center justify-center group relative overflow-hidden"
        aria-label="Contacter sur WhatsApp"
      >
        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
        <Icon name="MessageCircle" size={28} color="white" className="relative z-10" />

        <div className="absolute -top-1 -right-1 w-5 h-5 bg-[var(--color-error)] rounded-full flex items-center justify-center">
          <span className="text-white text-xs font-bold">1</span>
        </div>

        <div className="absolute inset-0 rounded-full border-2 border-white opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"></div>
      </button>
    </div>
  );
};

export default WhatsAppFloat;